import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';

// Escala de resposta padrão para todas as perguntas
export const OPCOES_ESCALA = ['Sempre', 'Quase sempre', 'Às vezes', 'Raramente', 'Nunca'];

// Blocos temáticos conforme o PDF da pesquisa
export const BLOCOS = [
    {

        perguntas: [
            { id: 'P_1', texto: 'Você consegue fazer suas pausas (break) e descanso normalmente.' },
            { id: 'P_2', texto: 'Você consegue terminar suas tarefas dentro do horário de trabalho.' },
            { id: 'P_3', texto: 'A quantidade de trabalho durante o dia é adequada para você dar conta.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_4', texto: 'Você entende o que precisa fazer no seu trabalho.' },
            { id: 'P_5', texto: 'O ritmo de trabalho é compatível com minha capacidade.' },
            { id: 'P_6', texto: 'Quando surge um problema, alguém orienta você sobre o que fazer.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_7', texto: 'Tenho um bom relacionamento com meus colegas de trabalho.' },
            { id: 'P_8', texto: 'Os desentendimentos no trabalho são resolvidos com calma.' },
            { id: 'P_9', texto: 'O ambiente de trabalho é respeitoso.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_10', texto: 'As orientações que você recebe são claras.' },
            { id: 'P_11', texto: 'Quando há mudanças no trabalho, você é avisado com antecedência.' },
            { id: 'P_12', texto: 'Quando você tem dúvida, consegue receber explicações.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_13', texto: 'As decisões no trabalho são tomadas de forma adequada.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_14', texto: 'Seus líderes são acessíveis quando você precisa falar.' },
            { id: 'P_15', texto: 'Quando você tem dificuldade, recebe apoio.' },
            { id: 'P_16', texto: 'Suas responsabilidades são explicadas com clareza.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_17', texto: 'Seu trabalho é reconhecido quando você faz bem feito.' },
            { id: 'P_18', texto: 'As regras são aplicadas da mesma forma para todos.' },
            { id: 'P_19', texto: 'Você é tratado com respeito pela empresa.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_20', texto: 'O local onde você trabalha permite fazer suas tarefas com segurança.' },
            { id: 'P_21', texto: 'Os equipamentos necessários para o trabalho estão disponíveis.' },
            { id: 'P_22', texto: 'As orientações de segurança são fáceis de entender.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_23', texto: 'Você consegue dividir seu tempo entre trabalho e vida pessoal.' },
            { id: 'P_24', texto: 'Você inicia o dia de trabalho com disposição.' },
        ]
    },
    {

        perguntas: [
            { id: 'P_25', texto: 'Você sabe como comunicar problemas no trabalho.' },
            { id: 'P_26', texto: 'Você se sente à vontade para relatar situações difíceis.' },
            { id: 'P_27', texto: 'A empresa demonstra preocupação com o bem-estar dos funcionários.' },
        ]
    },
];

// Inicializa o estado com todas as 27 perguntas vazias
const estadoInicial = () => {
    const estado = {};
    BLOCOS.forEach(bloco => bloco.perguntas.forEach(p => { estado[p.id] = ''; }));
    return estado;
};

function PesquisaClima_Externo() {
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [enviando, setEnviando] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [respostas, setRespostas] = useState(estadoInicial());

    // Validação: verifica quais perguntas ainda não foram respondidas
    const perguntasNaoRespondidas = () => {
        return Object.entries(respostas)
            .filter(([, v]) => !v)
            .map(([k]) => k);
    };

    useEffect(() => {
        const validarLink = async () => {
            try {
                const response = await fetch(`/api/forms-rh/pesquisaclima/public/validar-link/${token}`);
                const data = await response.json();
                if (!response.ok) throw new Error(data.message || 'Erro ao validar link.');
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };
        validarLink();
    }, [token]);

    const handleChange = (id, valor) => {
        setRespostas(prev => ({ ...prev, [id]: valor }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const pendentes = perguntasNaoRespondidas();
        if (pendentes.length > 0) {
            alert(`Por favor, responda todas as perguntas antes de enviar.\n\n${pendentes.length} pergunta(s) sem resposta.`);
            return;
        }

        setEnviando(true);
        try {
            const response = await fetch('/api/forms-rh/pesquisaclima/public/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, respostas })
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.message || 'Erro ao enviar respostas.');
            }
            setSuccess(true);
        } catch (err) {
            alert('Erro ao enviar: ' + err.message);
        } finally {
            setEnviando(false);
        }
    };

    // --- Estilos compartilhados ---
    const cardStyle = {
        backgroundColor: '#fff',
        padding: '24px',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    };

    // --- Telas de estado ---
    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8fafc', color: '#64748b', fontSize: '18px' }}>
            Carregando pesquisa...
        </div>
    );

    if (error) return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#fef2f2', color: '#991b1b', padding: '20px', textAlign: 'center' }}>
            <div style={{ fontSize: '60px', marginBottom: '16px' }}>⚠️</div>
            <h2 style={{ fontSize: '22px', marginBottom: '10px' }}>Link Inválido ou Expirado</h2>
            <p style={{ maxWidth: '400px', lineHeight: 1.6 }}>{error}</p>
        </div>
    );

    if (success) return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#ecfdf5', color: '#065f46', padding: '20px', textAlign: 'center' }}>
            <div style={{ fontSize: '70px', marginBottom: '16px' }}>✅</div>
            <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Pesquisa Enviada!</h2>
            <p style={{ maxWidth: '400px', lineHeight: 1.6, color: '#047857' }}>
                Obrigado pela sua participação. Suas respostas são anônimas e serão usadas para melhorar o ambiente de trabalho.
            </p>
        </div>
    );

    const totalPerguntas = Object.keys(respostas).length;
    const totalRespondidas = Object.values(respostas).filter(v => v).length;
    const progressoPct = Math.round((totalRespondidas / totalPerguntas) * 100);

    return (
        <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', padding: '40px 20px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            <div style={{ width: '100%', maxWidth: '720px', margin: '0 auto' }}>

                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '28px' }}>
                    <img 
                        alt="Grupo Correia" 
                        src="/icon-logotipo.png" 
                        style={{ 
                            height: '120px', // Altura reduzida para melhor ajuste
                            maxWidth: '100%', // Garante responsividade
                            objectFit: 'contain' 
                        }} 
                    />
                </div>

                {/* Cabeçalho informativo - Versão Fixa (sem seta e sempre aberta) */}
                <div style={{ backgroundColor: '#f3f0ff', borderLeft: '4px solid #7c3aed', padding: '20px', borderRadius: '8px', marginBottom: '20px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                        <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#5b21b6', margin: 0 }}>Informações sobre a Pesquisa</h2>

                    </div>
                    
                    {/* Conteúdo sempre visível */}
                    <div style={{ color: '#4c1d95', fontSize: '14px', lineHeight: 1.7 }}>
                        <p style={{ margin: '0 0 10px 0' }}>
                            <strong>Sua participação é muito importante!</strong>
                        </p>
                        <ul style={{ paddingLeft: '20px', margin: '0 0 10px 0' }}>
                            <li><strong>Pesquisa anônima:</strong> Suas respostas são 100% confidenciais. Nenhum dado individual será identificado.</li>
                            <li><strong>Objetivo:</strong> Entender melhor a experiência e a percepção da equipe sobre o dia a dia no trabalho, contribuindo para melhorias contínuas no ambiente e na rotina.</li>
                            <li><strong>Sigilo:</strong> Os resultados são analisados apenas de forma coletiva, nunca individualmente.</li>
                        </ul>
                        <p style={{ margin: 0, borderTop: '1px solid #ddd6fe', paddingTop: '10px' }}>
                            <strong>Orientação:</strong> Responda pensando na sua rotina habitual. Não existem respostas certas ou erradas — queremos conhecer sua percepção real.
                        </p>
                    </div>
                </div>

                {/* Barra de progresso */}
                <div style={{ ...cardStyle, padding: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '13px', color: '#64748b' }}>
                        <span>Progresso</span>
                        <span style={{ fontWeight: 'bold', color: progressoPct === 100 ? '#10b981' : '#475569' }}>
                            {totalRespondidas} / {totalPerguntas} perguntas respondidas
                        </span>
                    </div>
                    <div style={{ backgroundColor: '#e2e8f0', borderRadius: '99px', height: '10px', overflow: 'hidden' }}>
                        <div style={{
                            width: `${progressoPct}%`,
                            height: '100%',
                            backgroundColor: progressoPct === 100 ? '#10b981' : '#7c3aed',
                            borderRadius: '99px',
                            transition: 'width 0.3s ease'
                        }} />
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    {BLOCOS.map((bloco, blocoIdx) => {
                        const todasRespondidas = bloco.perguntas.every(p => respostas[p.id]);
                        return (
                            <div key={blocoIdx} style={cardStyle}>
                                {/* Título do Bloco */}

                                {/* Indicador de bloco completo */}
                                {todasRespondidas && (
                                    <div style={{ textAlign: 'right', marginBottom: '12px', marginTop: '-10px' }}>
                                        <span style={{ color: '#10b981', fontSize: '20px', fontWeight: 'bold' }}>✓ Completo</span>
                                    </div>
                                )}

                                {/* Perguntas do bloco */}
                                {bloco.perguntas.map((pergunta, pIdx) => {
                                    const numero = BLOCOS.slice(0, blocoIdx).reduce((acc, b) => acc + b.perguntas.length, 0) + pIdx + 1;
                                    const valorAtual = respostas[pergunta.id];
                                    return (
                                        <div key={pergunta.id} style={{ marginBottom: pIdx < bloco.perguntas.length - 1 ? '28px' : '4px' }}>
                                            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#334155', marginBottom: '12px', lineHeight: '1.5' }}>
                                                <span style={{ color: '#7c3aed', marginRight: '6px' }}>{numero}.</span>
                                                {pergunta.texto}
                                            </label>
                                            {/* Botões da escala */}
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '6px' }}>
                                                {OPCOES_ESCALA.map(opcao => {
                                                    const selecionado = valorAtual === opcao;
                                                    const radioId = `${pergunta.id}-${opcao}`;
                                                    return (
                                                        <Fragment key={opcao}>
                                                            <input
                                                                type="radio"
                                                                id={radioId}
                                                                name={pergunta.id}
                                                                value={opcao}
                                                                checked={selecionado}
                                                                onChange={() => handleChange(pergunta.id, opcao)}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <label
                                                                htmlFor={radioId}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '10px 4px',
                                                                    fontSize: '11px',
                                                                    textAlign: 'center',
                                                                    lineHeight: '1.3',
                                                                    backgroundColor: selecionado ? '#7c3aed' : '#f8fafc',
                                                                    color: selecionado ? '#fff' : '#475569',
                                                                    border: `2px solid ${selecionado ? '#7c3aed' : '#e2e8f0'}`,
                                                                    borderRadius: '8px',
                                                                    cursor: 'pointer',
                                                                    fontWeight: selecionado ? 'bold' : 'normal',
                                                                    transition: 'all 0.15s ease',
                                                                    minHeight: '52px'
                                                                }}
                                                            >
                                                                {opcao}
                                                            </label>
                                                        </Fragment>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}

                    {/* Aviso de completude */}
                    {progressoPct < 100 && (
                        <div style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px', padding: '14px', marginBottom: '16px', fontSize: '13px', color: '#92400e' }}>
                            ⚠️ Responda todas as {totalPerguntas} perguntas para enviar a pesquisa. Faltam <strong>{totalPerguntas - totalRespondidas}</strong>.
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={enviando || progressoPct < 100}
                        style={{
                            width: '100%',
                            padding: '16px',
                            backgroundColor: progressoPct < 100 ? '#94a3b8' : (enviando ? '#7c3aed99' : '#7c3aed'),
                            color: '#fff',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: progressoPct < 100 || enviando ? 'not-allowed' : 'pointer',
                            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
                            transition: 'background-color 0.2s',
                            marginBottom: '40px'
                        }}
                    >
                        {enviando ? 'Enviando Respostas...' : progressoPct < 100 ? `Responda todas as perguntas (${totalRespondidas}/${totalPerguntas})` : 'Enviar Pesquisa'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default PesquisaClima_Externo;